import { QuestionCircleOutlined } from '@ant-design/icons'
import { Alert } from 'antd'
import { useTheme } from 'antd-style'
import { toNumber } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'

export const AuditResultAlert = () => {
  const { detailData = {} } = useCrudFormStore(state =>
    pick(state, ['detailData'])
  )
  const { auditStatus, auditMessage } = detailData

  const { colorWarning, marginSM } = useTheme()

  return toNumber(auditStatus) === 2 ? (
    <Alert
      closable
      showIcon
      style={{ marginBlockEnd: marginSM }}
      title={auditMessage}
      type='warning'
      icon={
        <div style={{ color: colorWarning, verticalAlign: 'center' }}>
          <QuestionCircleOutlined />
          &nbsp;未通过原因：{auditMessage}
        </div>
      }
    />
  ) : null
}
